import script from "./ElementCreateSelection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementCreateSelection.vue?vue&type=script&lang=ts&setup=true"

import "./ElementCreateSelection.vue?vue&type=style&index=0&id=85b0bbaa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85b0bbaa"]])

export default __exports__